import PrototypeLoader from 'components/Loader/PrototypeLoader'
import React from 'react'
import styled from 'styled-components'

/**
 * TODO: reuse code between Layout and LoadingPage
 * https://github.com/sketch-hq/Cloud/issues/3543
 *
 * Also, if you are changing Container or LoadingStateContainer
 * change PrototypeView as well
 */
const Container = styled.div`
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background.dark.base};
`

const LoadingStateContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`
export const PrototypeLoadingPage = () => (
  <Container>
    <LoadingStateContainer>
      <PrototypeLoader percentage={0} />
    </LoadingStateContainer>
  </Container>
)
